import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CheckAuth } from 'src/Services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { ToolEnum } from 'src/Models/Common';
import { CarrierTariffsModel } from 'src/Models/CarrierTariffsModel';
import { FilterModel } from 'src/Models/filterModel';
import { I360Service } from 'src/Services/i360Service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-carrier-tariffs',
  templateUrl: './carrier-tariffs.component.html',
  styleUrls: ['./carrier-tariffs.component.css']
})
export class CarrierTariffsComponent implements OnInit {

  filterModel = new FilterModel();
  currentPage: number = 1;
  totalRecordCount: number = -1;

  listOfCarrierTariffs: CarrierTariffsModel[];
  listOfCarrierTariffsExport: CarrierTariffsModel[];

  isUserSystemAdmin: boolean = true;
  tokenKey: string = '';
  SelectedTool: string;

  isAscending: boolean = false
  upDowTitleCSS: string = '';
  upDowURLCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowModifiedDateCSS: string = '';

  productId: number = 1;
  deletedId: number = 0;
  isloading: boolean;
  openMenuIndex: number = -1;


  constructor(private readonly i360service: I360Service,
    private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Carrier Tariffs');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'ISNULL(ModifiedTime,CreatedTime) DESC';
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.GetCarrierTariffsData();
  }

  GetCarrierTariffsData() {
    this.listOfCarrierTariffs = [];
    this.isloading = true;
    this.filterModel.IsExport = false;
    this.i360service.i360CarrierTariffsGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.listOfCarrierTariffs = data['carrierTariffsData'];
          if (this.listOfCarrierTariffs != null) {
            if (this.listOfCarrierTariffs.length > 0) {
              this.totalRecordCount = this.listOfCarrierTariffs[0].totalRecordCount;
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  keywordFilters($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    if ($event.target.value != "" && $event.target.value != null) {
      this.filterModel.whereCondition = $event.target.value;
    }
    else {
      this.filterModel.whereCondition = '';
    }
    this.GetCarrierTariffsData();
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.GetCarrierTariffsData();
  }

  sort(sortBy: any) {
    this.upDowTitleCSS = '';
    this.upDowURLCSS = '';
    this.upDowIsActiveCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowModifiedDateCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "url") {
        this.upDowURLCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "isActive") {
        this.upDowIsActiveCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "createdTime") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "modifiedTime") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "url") {
        this.upDowURLCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "isActive") {
        this.upDowIsActiveCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "createdTime") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "modifiedTime") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-up';
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetCarrierTariffsData();
  }

  addCarriertariff() {
    this.router.navigate(['admin/jsi360/carriertariff/manage']);
  }

  editData(ids) {
    this.router.navigate(['admin/jsi360/carriertariff/manage/' + ids])
  }

  setDeleteData(ids) {
    this.deletedId = ids;
  }

  deleteRecord(deletedId) {
    this.i360service.i360CarrierTariffsDelete(this.tokenKey, deletedId).subscribe(
      data => {
        this.deletedId = 0;
        if (data != null) {
          if (data['deletedId'] > 0) {
            this.GetCarrierTariffsData();
            this.toastr.success('Record deleted successfully.', 'Delete')
          }
        }
      },
      error => {
      }
    );
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportCarrier() {
    this.isloading = true;
    this.filterModel.IsExport = true;
    this.listOfCarrierTariffsExport = [];
    this.i360service.i360CarrierTariffsGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfCarrierTariffsExport = data['carrierTariffsData'];
          if (this.listOfCarrierTariffsExport.length > 0) {
            setTimeout(() => {
              this.DownloadCarrier();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadCarrier() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportJSi360CarrierTariffs';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportJSi360CarrierTariffs.xls");
  }
}
